import { ListScreen, StackScreenProps } from '@rahtab/stack-navigator';
import { Colors, getSpacing, ItemCard, ListEmpty, Picker, Tag, Text, TextView } from '@rahtab/ui';
import SortIcon from '@rahtab/ui/dist/icons/SortIcon';
import React from 'react';
import { StyleSheet, View } from 'react-native';
import InvoiceListEmptyIcon from '@rahtab/ui/dist/icons/ListEmptyIcons/BillingHistory';
import useInvoiceList from 'hooks/‌Bill/useInvoiceList';
import { withToman } from '@rahtab/system/lib/tools/string';
import { RootStackType } from '../../Router';

const InvoiceList: React.VFC<InvoiceListProps> = ({ route }) => {
  const { transactionCount } = route.params;
  const { refetch, called, data, loading, fetchMore, hasNextPage } = useInvoiceList(0);
  return (
    <ListScreen
      title="سوابق پرداخت"
      loading={loading}
      refreshing={called && loading}
      onRefresh={refetch}
      renderControls={() => {
        return (
          <View style={styles.rowView}>
            <TextView
              title="تراکنش‌ها"
              value={transactionCount}
              style={styles.textView}
              isSpaceBetween
              marginBottom={0}
            />
            <Picker
              selectedValue="newest"
              color="primary"
              marginBottom={0}
              variant="outlined"
              customIcon={<SortIcon fill={Colors.primary} />}
              style={styles.picker}>
              <Picker.Item label="جدیدترین پرداخت‌ها" value="newest" />
            </Picker>
          </View>
        );
      }}
      ListEmptyComponent={<ListEmpty text="سابقه پرداخت وجود ندارد." imageComponent={<InvoiceListEmptyIcon />} />}
      listData={data}
      onEndReached={() => {
        if (hasNextPage) fetchMore({ params: `RowID=${data.length}&Count=10` });
      }}
      keyExtractor={(id) => `bill-${id}`}
      renderItem={({ item }) => {
        const { statusText, paidAt, total, from, to, id } = item;
        return (
          <ItemCard
            statusBadge={<Tag text={statusText} backgroundColor={'green'} color={'white'} />}
            screenName={'PaymentInfo'}
            params={{ id }}
            caption={
              <Text color="description" margin="none">
                زمان پرداخت: <Text>{paidAt}</Text>
              </Text>
            }>
            <Text>
              صورت‌حساب{' '}
              <Text>
                {from} - {to}
              </Text>
            </Text>
            <Text color="description">
              مبلغ صورت‌حساب: <Text>{withToman(total)}</Text>
            </Text>
          </ItemCard>
        );
      }}
    />
  );
};

export default InvoiceList;

const styles = StyleSheet.create({
  rowView: {
    flexDirection: 'row',
    alignItems: 'center',
    marginTop: getSpacing(),
  },
  textView: {
    flex: 1,
    marginRight: getSpacing(),
  },
  picker: {
    flex: 2,
  },
});

type InvoiceListProps = StackScreenProps<RootStackType, 'InvoiceList'>;
